import React from 'react';
import '../App.scss';
import { getThemeColor } from './ThemeColor'
import {EGAPRO_CONTENT, HANDIPSY_CONTENT, SANTE_SECURITE_AU_TRAVAIL_CONTENT} from "../codes";

class Accueil extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange() {
        this.props.onPageChange("", "");
    }

    render() {
        const logoEntrepriseSyle = {
            backgroundImage: 'url(' + this.props.version.logo + ')',
        };
        // Affichage Page accueil
        return (
            <div className="Splashscreen">
                <div className="LogoContainer Left">
                    <div className="LogoEntreprise Left" style={logoEntrepriseSyle}></div>
                    {this.props.quizContent === EGAPRO_CONTENT && <div className="Title">Égalité professionnelle</div>}
                    {this.props.quizContent === SANTE_SECURITE_AU_TRAVAIL_CONTENT && <div className="Title">Santé au travail</div>}
                    {this.props.quizContent === HANDIPSY_CONTENT && <div className="Title">HANDICAP PSYCHIQUE</div>}
                </div>
                <div className="BandesContainer Rayures"></div>
                <div className="SplashscreenFooter" style={{backgroundColor: getThemeColor(this.props.quizContent)}}>
                    <button onClick={() => this.handleChange()}>
                        <i className="StartButton"></i>
                        {this.props.wordings['ui.btn.start']}
                    </button>
                </div>
            </div>
        )
    }
}

export default Accueil;
